import React, { useMemo } from "react";
import RepeatableObjectField, {
  type FieldDef,
} from "@components/RepeatableField/RepeatableObjectField";
import type { FormContext } from "@features/port-security/components/SecurityClearence.types.ts";
import { usePortSecurityFormStore } from "@features/port-security/store/usePortSecurityForm.store.ts";
import { useFormattedReference } from "@hooks/useFormattedReference";
import type { Nationality } from "@services/gatepass/types";
import { REFERENCE_DATA_TYPES } from "@services/referenceDataApi";
import { t } from "i18next";
import { FormProvider } from "react-hook-form";
import { useOutletContext } from "react-router-dom";

const Friends: React.FC = () => {
  const { formData } = useOutletContext<FormContext>();
  const { setField } = usePortSecurityFormStore();
  const { options: nationalities } = useFormattedReference<Nationality>(
    REFERENCE_DATA_TYPES.NATIONALITY,
    "bff-gatepass",
  );
  const nationalitiesOptions = useMemo(
    () =>
      nationalities
        .map((n) => ({ label: n.nationality, value: n.nationality }))
        .sort((a, b) => a.label.localeCompare(b.label)),
    [nationalities],
  );

  const defs: FieldDef[] = [
    { key: "name", label: t("security-clearance.name"), type: "text", maxChars: 200 },
    {
      key: "nationality",
      label: t("security-clearance.nationality"),
      type: "autocomplete",
      options: nationalitiesOptions,
    },
    { key: "workPlace", label: t("security-clearance.work-place"), type: "text", maxChars: 200 },
  ];
  return (
    <FormProvider {...formData}>
      <RepeatableObjectField
        name="friends"
        numberOfColumns={3}
        sectionLabel={t("security-clearance.friends")}
        label={t("security-clearance.friend-entry")}
        fields={defs}
        minItems={1}
        maxItems={3}
        addButtonLabel={t("security-clearance.add-friend")}
        onFieldChange={(_key, arr: unknown[]) => {
          setField("friends", arr as { name: string; nationality: string; workPlace: string }[]);
        }}
        testId="friends-repeatable-field"
      />
    </FormProvider>
  );
};

export default Friends;
